<div class="flex flex-1 flex-row">
  @for (tag of tags; track tag; let isLast = $last) {
    <div
      (click)="tag.onClickEmit($event)"
      class="py-1 px-1
    flex items-center justify-center
    rounded-md overflow-hidden whitespace-nowrap text-ellipsis
    transition-colors
    {{ isLast ? '' : 'mr-2' }} {{
        tag.class ? tag.class : 'bg-slate-200 hover:bg-slate-300 text-slate-800'
      }}"
      [class.w-12]="tag.size === 'xs'"
      [class.w-16]="tag.size === 'sm'"
      [class.w-20]="tag.size === 'md'"
      [class.w-24]="tag.size === 'xl'"
      [class.w-28]="tag.size === 'lg'"
    >
      <span>
        {{ tag.value }}
      </span>
      @if (tag.buttonOptions) {
        <snt-button-icon
          #button
          [disabled]="tag.disabled()"
          [icon]="tag.buttonOptions.icon"
          (onClick)="tag.onButtonClick.emit(button)"
          class="ml-auto"
        ></snt-button-icon>
      }
    </div>
  }
</div>
